export default "__VITE_PUBLIC_ASSET__8bd9da1c__"